<ng-container
  [ngTemplateOutlet]="template"
  [ngTemplateOutletContext]="{
    contactTypes: (contactTypes$ | async) ?? [],
    results: (results$ | async) ?? []
  }"
>
</ng-container>
<ng-template #template let-contactTypes="contactTypes" let-results="results">
  <h1 mat-dialog-title>
    <span>{{ action + " Contact" }}</span>
  </h1>
  <mat-dialog-content>
    <form #form="ngForm" flexLayout="column" flexLayoutAlign="space-around">
      <div flexLayout="row" flexLayoutGap="10px">
        <mat-form-field flex="50">
          <mat-label>Contact Type</mat-label>
          <mat-select [(ngModel)]="contact.contactType" required name="contactType">
            @for (contactType of contactTypes; track contactType) {
              <mat-option [value]="contactType">{{ contactType }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field flex="50">
          <mat-label>Result</mat-label>
          <mat-select [(ngModel)]="contact.result" required name="result">
            @for (result of results; track result) {
              <mat-option [value]="result">{{ result }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <mat-form-field>
        <mat-label>Notes</mat-label>
        <textarea
          rows="4"
          title="Notes"
          matInput
          [(ngModel)]="contact.notes"
          required
          name="notes"
        ></textarea>
      </mat-form-field>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions flexLayout="row" flexLayoutAlign="end center">
    <button type="button" mat-flat-button [mat-dialog-close]>Cancel</button>
    <button
      type="button"
      mat-raised-button
      color="primary"
      (click)="saveContact()"
      [disabled]="!form.valid"
    >
      Save
    </button>
  </mat-dialog-actions>
</ng-template>
